<template>
  <div class="wrapper swiper-container">
    <ProductContent class="texh" :title="techTitle" :content="techContent" id="tech"/>
    <swiper ref="mySwiper" :options="swiperOptions" class="swiper-wrapper-box">
      <swiper-slide>
        <div class="content">
          <div class="title">
            人工智能
            <p>深度学习/自然语义处理</p>
          </div>
          <div class="slideItem">
            <img src="@/assets/images/productOne.png" />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="content">
          <div class="title">
            区块链
            <p>供应链金融/预言机</p>
          </div>
          <div class="slideItem">
            <img src="@/assets/images/productTwo.png" />
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="content">
          <div class="title">
            智慧风控
            <p>节点智能监测/大数据风控</p>
          </div>
          <div class="slideItem">
            <img src="@/assets/images/productThree.png" />
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="swiper-button-prev" slot="button-prev" @click="prev"></div>
    <div class="swiper-button-next" slot="button-next" @click="next"></div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
// import 'swiper/css/swiper.css'
import ProductContent from "@/components/ProductContent"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
export default {
  components: {
    Swiper,
    SwiperSlide,
    ProductContent
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      techTitle:'鲁商通科技',
      techContent:' 以科学打造鲁商通理念，以技术助力鲁商通发展',
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // notNextTick: true,
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: 140,
        width: 1200,
        // Some Swiper option/callback...
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  mounted() {
    console.log("Current Swiper instance object", this.swiper);
    // this.swiper.slideTo(0, 1200, false);
    // var that = this
    // this.swiper.el.onmouseover=function(){
    //   window.console.log("onmouseover")
    // that.swiper.navigation.$nextEl.removeClass('hide');
    // that.swiper.navigation.$prevEl.removeClass('hide');
    // }
    // this.swiper.el.onmouseout=function(){
    //   window.console.log("onmouseout")
      // that.swiper.navigation.$nextEl.addClass('hide');
      // that.swiper.navigation.$prevEl.addClass('hide');
    // }
  },
  methods: {
    // onmouseover(){
    //   window.console.log("onmouseover")
    // },
    // onmouseout(){
    //   window.console.log("onmouseout")
    // },
    prev() {
      this.swiper.slidePrev();
    },
    next() {
      this.swiper.slideNext();
    },
  },
};
</script>
<style lang="scss" scoped>
.swiper-container .hide {
  opacity: 0;
}
.swiper-button-next,
.swiper-button-prev {
  transition: opacity 0.5s;
}
.swiper-container {
  width: 1200px;
  height: 100%;
  margin-bottom: 30px;
}
.slideItem {
  // background: red;
  // height: 150px;
  img{
    width: 100%;
  }
}
.title {
  color: #ffffff;
  font-size: 24px;
  // padding: 20px;
  padding: 30px 20px 40px 20px;
  background:linear-gradient(-90deg,rgba(249,80,1,1),rgba(252,98,14,1));
  p {
    font-size: 18px;
    color: #fffefe;
    padding-top: 8px;
  }
}
.swiper-button-prev {
  width: 50px;
  height: 50px;
  background: url("../assets/images/left.png") no-repeat;
  background-size: 100% 100%;
}
.swiper-button-next {
  width: 50px;
  height: 50px;
  background: url("../assets/images/right.png") no-repeat;
  background-size: 100% 100%;
}
@media (max-width: 767.98px) {
::v-deep .midText{
  background: #F2F2F2;
}
::v-deep .swiper-wrapper{
    display: flex;
    flex-direction: column !important;
  }
  .swiper-container{
    width: 100%;
    margin-bottom: 22px;
  }
  .swiper-slide{
    width: 100% !important;
  }
  .swiper-button-prev{
    display: none;
  }
  .swiper-button-next{
    display: none;
  }
  .swiper-slide{
    margin-bottom: 30px;
  }
  .content{
    // margin-left: 20px;
    // margin-right: 20px;
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }
  .title{
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .slideItem img{
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }

}
</style>
<style>
.swiper-slide {
  /* background: linear-gradient(
    -90deg,
    rgba(249, 80, 1, 1),
    rgba(252, 98, 14, 1)
  ); */
}
</style>